// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const POST_DELETED_BY_ADMIN = "Pr\u00edspevok zmazan\u00fd adminom";
export const POST_DELETED_BY_AUTHOR = "Pr\u00edspevok zmazan\u00fd autorom";
export const POST_DELETED_BY_MODERATOR = "Pr\u00edspevok zmazan\u00fd moder\u00e1torkou";
